import VueCookie from 'vue-cookie';
import axios, { AxiosInstance } from 'axios';
import { ENDPOINTS } from '@/settings/endpoints';
import SentryClient from '@/helpers/sentry';

interface ResultDto {
  message: string;
  identifier: string;
  data: object;
}

export class GrowthNotificationService {
  private gateway: AxiosInstance;

  constructor() {
    const tokenD = VueCookie.get('d', { domain: '.descomplica.com.br' });
    this.gateway = axios.create({
      baseURL: `${ENDPOINTS.pegasusSilver}growth`,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${tokenD}`,
      },
    });
  }

  async notify(email: string): Promise<ResultDto | void> {
    try {
      await this.gateway.post(`/notification/`, {
        email,
      });
    } catch (error) {
      SentryClient.captureError(error);
    }
  }
}
